import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormCreateCustomModelActionParams {
  form: UseFormReturn<BaseVehicle>;
  customModel: string;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;
/**
 * XState action for creating a custom vehicle model
 * Only handles setting custom model values - field resets are handled separately
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance and custom model value
 */
export const formCreateCustomModelAction = (
  _context: unknown,
  params: FormCreateCustomModelActionParams
): void => {
  const {form, customModel} = params;

  // Set the custom model in form
  form.setValue('customModelFamily', customModel);
  form.setValue('formModelFamily', customModel);
  form.setValue('modelFamily', customModel, DEFAULT_OPTIONS);

  // Add to unknown models for UI state
  const currentUnknownModels = form.getValues('unknownModels') ?? [];
  const newModelOption = {value: customModel, label: customModel};

  if (!currentUnknownModels.some((model) => model.value === customModel)) {
    form.setValue('unknownModels', [...currentUnknownModels, newModelOption]);
  }
};
